import React, { useState } from "react";
import { db } from "../firebase";
import {
  doc,
  getDoc,
  updateDoc,
  setDoc,
  serverTimestamp
} from "firebase/firestore";

import bgImage from "../assets/background.png";

function LicenseActivation() {
  const [licenseKey, setLicenseKey] = useState("");
  const [showRegistration, setShowRegistration] = useState(false);
  const [shopName, setShopName] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [mobile, setMobile] = useState("");

  const handleActivate = async () => {
    try {
      const licenseRef = doc(db, "licenses", licenseKey);
      const licenseSnap = await getDoc(licenseRef);

      if (!licenseSnap.exists()) {
        alert("Invalid License Key");
        return;
      }

      const data = licenseSnap.data();

      if (data.isActivated) {
        localStorage.setItem("isActivated", "true");
        localStorage.setItem("shopId", data.shopId);
        window.location.reload();
      } else {
        setShowRegistration(true);
      }
    } catch (error) {
      console.error(error);
      alert("Activation Failed");
    }
  };

  const registerShop = async () => {
    try {
      if (!shopName || !ownerName || !mobile) {
        alert("Fill all fields");
        return;
      }

      const shopId = "shop_" + Date.now();

      await updateDoc(doc(db, "licenses", licenseKey), {
        isActivated: true,
        shopId,
        shopName,
        ownerName,
        mobile,
      });

      await setDoc(doc(db, "shops", shopId), {
        shopId,
        shopName,
        ownerName,
        mobile,
        licenseKey,
        createdAt: serverTimestamp(),
      });

      localStorage.setItem("shopId", shopId);
      localStorage.setItem("isActivated", "true");
      alert("Shop Activated Successfully");
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("Activation Failed");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end", 
        padding: "0 5%",
        backgroundImage: `url(${bgImage})`, 
        
        backgroundSize: "contain", 
        backgroundPosition: "left center", // Aligns the image to the left
        backgroundColor: "#061535", // The perfectly matched dark blue
        
        backgroundRepeat: "no-repeat",
        fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      {/* Right Side Card Container */}
      <div
        style={{
          width: "100%",
          maxWidth: "520px",
          background: "#ffffff",
          padding: "40px",
          borderRadius: "20px",
          boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header Section */}
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <div
            style={{
              width: "60px",
              height: "60px",
              background: "#e8f0fe",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0056ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              <polyline points="9 12 11 14 15 10"></polyline>
            </svg>
          </div>
          <h2 style={{ margin: "0 0 10px 0", color: "#111827", fontSize: "24px", fontWeight: "600" }}>
            {showRegistration ? "Register Your Shop" : "Activate Your License"}
          </h2>
          <p style={{ margin: 0, color: "#6b7280", fontSize: "14px" }}>
            {showRegistration 
              ? "Please provide your business details to complete activation" 
              : "Enter your license key to activate MyOwnBill on this device"}
          </p>
        </div>

        {!showRegistration ? (
          /* ----- STEP 1: LICENSE ACTIVATION UI ----- */
          <>
            <div style={{ marginBottom: "20px" }}>
              <label style={{ display: "block", marginBottom: "8px", color: "#374151", fontSize: "14px", fontWeight: "500" }}>
                License Key
              </label>
              <div style={{ position: "relative" }}>
                <div style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#9ca3af", display: "flex" }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="XXXX-XXXX-XXXX-XXXX-XXXX"
                  value={licenseKey}
                  onChange={(e) => setLicenseKey(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "12px 12px 12px 40px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    fontSize: "15px",
                    outline: "none",
                    boxSizing: "border-box",
                    transition: "border-color 0.2s",
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#0056ff"}
                  onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                />
              </div>
              <div style={{ marginTop: "8px" }}>
                <a href="#" style={{ color: "#0056ff", fontSize: "13px", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "4px" }}>
                  Where can I find my license key?
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                  </svg>
                </a>
              </div>
            </div>

            {/* Why Activate Box */}
            <div style={{ background: "#f3f6fc", padding: "20px", borderRadius: "10px", marginBottom: "25px" }}>
              <h4 style={{ margin: "0 0 15px 0", color: "#111827", fontSize: "15px", fontWeight: "600" }}>Why activate?</h4>
              <ul style={{ margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: "12px" }}>
                {[
                  { text: "Secure & Verify your software", icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M9 12l2 2 4-4" },
                  { text: "Enable data backup to cloud", icon: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9z" },
                  { text: "Get automatic updates & new features", icon: "M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.59-10.05l5.07-5.07" }
                ].map((item, i) => (
                  <li key={i} style={{ display: "flex", alignItems: "center", gap: "12px", color: "#4b5563", fontSize: "14px" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0056ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d={item.icon}></path>
                    </svg>
                    {item.text}
                  </li>
                ))}
              </ul>
            </div>

            {/* Buttons */}
            <button
              onClick={handleActivate}
              style={{
                width: "100%",
                padding: "14px",
                background: "#0056ff",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                transition: "background 0.2s"
              }}
              onMouseOver={(e) => e.target.style.background = "#0046d5"}
              onMouseOut={(e) => e.target.style.background = "#0056ff"}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
              Activate Now
            </button>

            <div style={{ display: "flex", alignItems: "center", margin: "20px 0", color: "#9ca3af", fontSize: "14px" }}>
              <div style={{ flex: 1, height: "1px", background: "#e5e7eb" }}></div>
              <span style={{ padding: "0 15px" }}>OR</span>
              <div style={{ flex: 1, height: "1px", background: "#e5e7eb" }}></div>
            </div>

            <button
              style={{
                width: "100%",
                padding: "14px",
                background: "white",
                color: "#374151",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                marginBottom: "10px",
                transition: "background 0.2s"
              }}
              onMouseOver={(e) => e.target.style.background = "#f9fafb"}
              onMouseOut={(e) => e.target.style.background = "white"}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
              </svg>
              Continue in Trial Mode
            </button>
            <p style={{ textAlign: "center", margin: 0, color: "#9ca3af", fontSize: "13px" }}>
              Trial mode is limited to 30 days
            </p>
          </>
        ) : (
          /* ----- STEP 2: REGISTRATION UI ----- */
          <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <input
              type="text"
              placeholder="Shop Name"
              value={shopName}
              onChange={(e) => setShopName(e.target.value)}
              style={{ width: "100%", padding: "14px", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "15px", boxSizing: "border-box", outline: "none" }}
            />
            <input
              type="text"
              placeholder="Owner Name"
              value={ownerName}
              onChange={(e) => setOwnerName(e.target.value)}
              style={{ width: "100%", padding: "14px", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "15px", boxSizing: "border-box", outline: "none" }}
            />
            <input
              type="text"
              placeholder="Mobile Number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              style={{ width: "100%", padding: "14px", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "15px", boxSizing: "border-box", outline: "none" }}
            />
            <button
              onClick={registerShop}
              style={{
                width: "100%",
                padding: "14px",
                marginTop: "10px",
                background: "#0056ff",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer"
              }}
            >
              Register Shop
            </button>
          </div>
        )}

        {/* Footer */}
        <div style={{ marginTop: "30px", paddingTop: "20px", borderTop: "1px solid #e5e7eb", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "14px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#6b7280" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
            Need help?
          </div>
          <div style={{ display: "flex", gap: "15px" }}>
            <a href="#" style={{ color: "#0056ff", textDecoration: "none" }}>Contact Support</a>
            <span style={{ color: "#d1d5db" }}>|</span>
            <a href="#" style={{ color: "#0056ff", textDecoration: "none", display: "flex", alignItems: "center", gap: "4px" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
              Buy License
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LicenseActivation;